const LEGACY_MEMBERS_KEY = 'familyMembersSettings';
const LEGACY_OWNER_KEY = 'familyMembersSettingsOwner';
const UNCLAIMED_OWNER = 'unclaimed';

// Retain the pre-auth identity for this page even if a full browser cache
// prevents adding the owner marker to localStorage.
let unsavedOwner = null;

const readStorage = (key) => {
  try { return localStorage.getItem(key); } catch (_) { return null; }
};

const parseObject = (raw) => {
  try {
    const value = JSON.parse(raw);
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  } catch (_) { return {}; }
};

const accountId = (value) => typeof value === 'string' && value.trim() ? value : null;

export const captureLegacyPortfolioOwner = () => {
  const existingOwner = readStorage(LEGACY_OWNER_KEY);
  if (existingOwner) return existingOwner;
  if (unsavedOwner) return unsavedOwner;
  if (!readStorage(LEGACY_MEMBERS_KEY)) return null;

  // Call before the auth listener writes the incoming session. Otherwise a new
  // account would inherit the previous account's browser-only portfolios.
  const previousSession = parseObject(readStorage('userSession'));
  const owner = accountId(previousSession?.user?.id)
    || accountId(readStorage('userId'))
    || UNCLAIMED_OWNER;
  try {
    localStorage.setItem(LEGACY_OWNER_KEY, owner);
  } catch (_) {
    unsavedOwner = owner;
  }
  return owner;
};

export const getLegacyPortfolioMembers = (userId) => {
  if (!accountId(userId)) return {};
  const owner = captureLegacyPortfolioOwner();
  if (owner === UNCLAIMED_OWNER || owner !== userId) return {};
  return parseObject(readStorage(LEGACY_MEMBERS_KEY));
};
